import { ImportOutlined, MoreOutlined } from '@ant-design/icons';
import { Button } from '@mm/components';
import { useModalActions } from '@mm/state/modules/modalsState/actions';
import classNames from 'classnames';
import React from 'react';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router';
import PAGES_HEAD_CONTENT from '../../../../../../common/components/MetaData/constants';
import MetaData from '../../../../../../common/components/MetaData/MetaData';
import { Menu } from '../AutomationEdit/DialogueEditor/NodeTypes/elements/NodeMenu/NodeMenu';
import styles from './AutomationHome.module.css';
import { AutomationIndex } from './AutomationIndex';

type Props = {
  className?: string;
};

export const AutomationHome = ({ className }: Props) => {
  const match = useRouteMatch<{ chatbotId: string; view?: string }>();
  const modalActions = useModalActions();

  const onImportAutomationClick = () => {
    modalActions.openImportAutomationModal();
  };

  const menu = [
    {
      disabled: false,
      children: (
        <div className={styles.menuItem}>
          {' '}
          <ImportOutlined className={styles.menuItemIcon} /> Import Automation
        </div>
      ),
      onClick: onImportAutomationClick,
    },
  ];

  return (
    <div className={classNames(className, styles.container)}>
      <MetaData
        title={PAGES_HEAD_CONTENT.AUTOMATIONS.title}
        description={PAGES_HEAD_CONTENT.AUTOMATIONS.meta.description}
      />
      <Menu
        className={styles.menu}
        menu={menu}
        direction="bottom"
        menuButton={
          <Button css={{ container: styles.menuButton }} color="secondary">
            <MoreOutlined className={styles.moreIcon} />
          </Button>
        }
        css={{ menu: styles.nodeMenu }}
      />
      <Switch>
        <Route
          path={`${match.path}/my`}
          render={() => <AutomationIndex className={styles.box} />}
        />
        <Redirect to={`${match.path}/my`} />
      </Switch>
    </div>
  );
};
